<template>
  <AppSkeletonCardTable v-if="loadingList"></AppSkeletonCardTable>
  <Card v-else>
    <template v-slot:title>
      Bovinos
      <router-link
        :to="{ name: 'bovine.list', query: { ownerId: id } }"
        target="_blank"
      >
        <br class="hide mobile-show" />
        <span style="font-size: 1rem; font-weight: normal">
          (Listagem de Bovinos do Proprietário)
        </span>
      </router-link>
    </template>
    <template v-slot:content>
      <BovineDataTable
        :results="results"
        :columns="[{ field: 'owner', hide: true }]"
        scrollHeight="800px"
      />
      <Paginator
        :rows="query.pageSize"
        :totalRecords="pagination.total"
        @page="({ page }) => changeListPage({ page: page + 1 })"
      ></Paginator>
    </template>
  </Card>
</template>

<script>
import BovineDataTable from '../../../components/BovineDataTable.vue';
import useApiList from '../../../lib/useApiList';
import { BovineApi } from '../../../services/api';

export default {
  name: 'OwnerBovineCard',
  props: {
    id: Number,
  },
  components: {
    BovineDataTable,
  },
  setup(props) {
    return {
      ...useApiList(BovineApi, {
        ownerId: props.id,
        pageSize: 10,
        available: true,
      }),
    };
  },
  async created() {
    await this.fetchList();
  },
};
</script>

<style>
</style>
